import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { getProductDetails } from "../data/actions/product";
import { toast } from "react-toastify";
import { addToCart } from "../data/actions/cart";

const ProductDetails = () => {
  const { id } = useParams();
  const dispatch = useDispatch();

  const { product } = useSelector((state) => state.productDetails);

  const [selectedSize, setSelectedSize] = useState("");
  const [selectedColor, setSelectedColor] = useState("");

  useEffect(() => {
    dispatch(getProductDetails(id));
  }, [dispatch, id]);

  if (!product) return null;

  const finalPrice =
    product.isOnSale && product.discountPercent > 0
      ? product.price - (product.price * product.discountPercent) / 100
      : product.price;

  const handleAddToCart = () => {
    if (!selectedSize || !selectedColor) {
      alert("Select size and color");
      return;
    }

    dispatch(
      addToCart({
        product: product._id,
        name: product.name,
        photo: product.photo,
        price: product.price,
        finalPrice,
        size: selectedSize,
        color: selectedColor,
        quantity: 1,
      })
    );
        toast.success("Added to cart 🛒", {
  position: "top-center",
});
  };

  return (
    <div className="p-10">
      <div className="grid md:grid-cols-2 gap-10">

        <img
          src={product.photo}
          className="w-full" alt={product.name || "product"}
        />

        <div>
          <h1 className="text-3xl font-bold">{product.name}</h1>

          {/* PRICE */}
          <div className="mt-4">
            {product.isOnSale ? (
              <>
                <span className="line-through mr-2">₹{product.price}</span>
                <span className="text-red-600 text-2xl font-bold">
                  ₹{finalPrice}
                </span>
              </>
            ) : (
              <span className="text-2xl font-bold">₹{product.price}</span>
            )}
          </div>

          {/* SIZE */}
          <div className="mt-6">
            <h3>Select Size</h3>
            <div className="flex gap-2 mt-2">
              {[...new Set(product.variants?.map(v => v.size))].map(size => (
                <button
                  key={size}
                  onClick={() => setSelectedSize(size)}
                  className={`px-3 py-1 border ${
                    selectedSize === size ? "bg-black text-white" : ""
                  }`}
                >
                  {size}
                </button>
              ))}
            </div>
          </div>

          {/* COLOR */}
          <div className="mt-6">
            <h3>Select Color</h3>
            <div className="flex gap-2 mt-2">
              {[...new Set(product.variants?.map(v => v.color.name))].map(color => (
                <button
                  key={color}
                  onClick={() => setSelectedColor(color)}
                  className={`px-3 py-1 border ${
                    selectedColor === color ? "bg-black text-white" : ""
                  }`}
                >
                  {color}
                </button>
              ))}
            </div>
          </div>

          <button
            onClick={handleAddToCart}
            className="mt-6 bg-blue-600 text-white px-6 py-3 rounded"
          >
            Add to Cart
          </button>
        </div>

      </div>
    </div>
  );
};

export default ProductDetails;
